import React from "react"
import { FooterWithCTA as Footer, SEO, Layout, Hero } from "@components"
import Content from "@components/pages/faq/Content.js"
import SideCTA from "@components/SideCTA"
import { webPageSchema, breadcrumbSchema, HOME_CRUMB } from "@utils/schema"
const TITLE = "DynamoDB FAQ: Keys, Queries, Costs and Operations"
const DESCRIPTION = "Find answers to DynamoDB questions about keys, queries, consistency, transactions, pricing and limits, with links to detailed explanations."

const FAQPage = () => {
  return (
    <>
      <Layout>
        <SEO
          title={TITLE}
          description={DESCRIPTION}
          canonical="https://dynobase.dev/dynamodb-faq/"
          jsonLd={[
            webPageSchema({
              name: TITLE,
              description:
                DESCRIPTION,
              path: "/dynamodb-faq/",
            }),
            breadcrumbSchema([HOME_CRUMB, { name: "DynamoDB FAQ" }]),
          ]}
        />
        <div
          style={{
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Hero title={TITLE} />
          <Content />
        </div>
        <Footer />
      </Layout>
      <SideCTA />
    </>
  )
}

export default FAQPage
